var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.822,
    height: 174.5,
    viewBox: "0 0 117.822 174.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#fcf9f9;}.c{fill:#4a4f60;}.d{fill:#eee;}.e,.n{fill:#d81212;}.f{fill:#f25555;}.g{fill:#6d8aa2;}.h{fill:#99adbe;}.i{fill:#e23123;}.j{fill:#e8d1b3;}.j,.k,.l,.m,.n,.o,.p,.q,.r{fill-rule:evenodd;}.k{fill:#16232c;}.l{fill:#adadad;}.m{fill:#dedede;}.o{fill:#ffd9c9;}.p{fill:#6f6571;}.q{fill:#d9d9d9;}.r{fill:#cbc7cb;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-172.932 -63)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 99.52,
    height: 169.388,
    rx: 30,
    transform: "translate(182.066 65.557)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.336,7.5H327a10.224,10.224,0,0,1,10.225,10.225V166.665A10.224,10.224,0,0,1,327,176.89h15.338a10.224,10.224,0,0,0,10.225-10.225V17.727A10.224,10.224,0,0,0,342.335,7.5Z",
    transform: "translate(-70.975 58.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M224.966,17.725H192.772A5.112,5.112,0,0,1,188.2,14.9l-3.7-7.4h48.737l-3.7,7.4a5.112,5.112,0,0,1-4.573,2.826Z",
    transform: "translate(22.957 58.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M194.351,174.5h-79.07A12.8,12.8,0,0,1,102.5,161.719V12.781A12.8,12.8,0,0,1,115.281,0h79.07a12.8,12.8,0,0,1,12.781,12.781V161.719A12.8,12.8,0,0,1,194.351,174.5ZM115.281,5.112a7.677,7.677,0,0,0-7.668,7.668V161.719a7.677,7.677,0,0,0,7.668,7.668h79.07a7.677,7.677,0,0,0,7.668-7.668V12.781a7.677,7.677,0,0,0-7.668-7.668Z",
    transform: "translate(77.01 63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M152.334,169.5h23.551v10.429a11.792,11.792,0,1,1-23.585,0Zm47.135,0H223.02v10.429a11.792,11.792,0,1,1-23.585,0Z",
    transform: "translate(44.182 -59.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148,169.5h23.551v10.429a11.792,11.792,0,1,1-23.585,0V169.5Zm-23.551,0V179.93c0,.2-.007.406-.017.607A11.792,11.792,0,0,1,110,191.419V169.5Zm85.069,0v21.925a11.794,11.794,0,0,1-14.4-10.889c-.01-.2-.017-.4-.017-.607V169.5Z",
    transform: "translate(72.066 -59.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M201.087,107.039l-42.534,5.112L83.3,107.039,92.289,84.33A1.994,1.994,0,0,1,94.853,83.2l11.58,4.412,8.7-5.112H133.06l11.126,5.112,7.142-5.112h17.893l11.908,5.112a10.507,10.507,0,0,1,14.46,5.534Z",
    transform: "translate(89.666 -2.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M152.334,154.5h23.551v10.429a11.792,11.792,0,1,1-23.585,0Zm47.135,0H223.02v10.429a11.792,11.792,0,1,1-23.585,0Z",
    transform: "translate(44.182 -49.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M367.267,107.039l-12.133,5.112-11.486-5.112-8.214-24.3L335.4,82.5h21a1.7,1.7,0,0,1,1.584,1.077Z",
    transform: "translate(-76.514 -2.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M221.5,107.039,224.158,82.5h18.268l2.658,24.539L232.1,112.151l-10.6-5.112Z",
    transform: "translate(-1.434 -2.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M115.133,82.5l-8.282,24.539-12.542,5.112L83.3,107.039l9.287-23.462A1.7,1.7,0,0,1,94.171,82.5Z",
    transform: "translate(89.666 -2.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M130.335,154.5h23.551v10.429a11.792,11.792,0,1,1-23.585,0V154.5Zm-47.1,0h23.551v10.429a11.792,11.792,0,1,1-23.585,0V154.5Zm94.237,0h23.551v10.429a11.792,11.792,0,0,1-23.585,0V154.5Z",
    transform: "translate(89.732 -49.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20.9,0A20.9,20.9,0,1,0,41.8,20.9,20.97,20.97,0,0,0,20.9,0ZM4.98,20.9A15.887,15.887,0,0,1,30.107,7.943L20.9,17.151,7.943,30.107A15.806,15.806,0,0,1,4.98,20.9ZM20.9,36.817a15.807,15.807,0,0,1-9.208-2.963L33.854,11.69A15.887,15.887,0,0,1,20.9,36.817Z",
    transform: "translate(210.791 144.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M276.9,20.9A20.97,20.97,0,0,1,256,41.8v-4.98A15.887,15.887,0,0,0,268.955,11.69L256,24.645V17.151l9.208-9.208A15.807,15.807,0,0,0,256,4.98V0A20.97,20.97,0,0,1,276.9,20.9Z",
    transform: "translate(-24.311 144.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M399.588,228.265H382.021v6.1a2.746,2.746,0,0,0,2.739,2.741h6.319l3.769,1.9,4.74-1.9v-8.844Z",
    transform: "translate(-184.9 -29.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M396.85,162.742H384.761a2.747,2.747,0,0,0-2.739,2.741v4.534h17.566v-4.534A2.747,2.747,0,0,0,396.85,162.742Z",
    transform: "translate(-184.9 27.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M399.589,206.463H382.022v4.309h17.566Z",
    transform: "translate(-184.9 -10.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M235.886,293.7h-8.509v3.914a1.711,1.711,0,0,0,1.7,1.706h27.7c0-2.461,0-3.713-1.883-3.713l-3.749,0c-2.36,0-3.907-.608-4.771-1.9h-10.5Z",
    transform: "translate(-21.199 -86.071)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M168.944,335.289H144.581c-1.429,2.488-2.577,5.478-1.587,11.2,1.658-5.64,18.494-3.389,20.223,3.12h18.577c.7-1.592,1.366-3.164,1.946-4.752H178.5C167.91,340.858,171.316,342.64,168.944,335.289Z",
    transform: "translate(63.303 -122.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M249.062,129.812a39.769,39.769,0,0,1-1.409,5.4l-5.355,2.1-5.971-2.1c.209-11.3,4.432-16.719,8.024-18.473a8.718,8.718,0,0,1,2.621-1.357s1.744,2.791,1.835,2.791a14.991,14.991,0,0,1,.88,5.925Z",
    transform: "translate(-15.313 68.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M208.376,262.108H219.7c2.609.284,5.817,2.271,5.817,8.425v6.45l-2.571,1.531-3.341-1.531V272c0-2.461,0-3.713-1.882-3.713l-3.749,0c-2.36,0-3.907-.608-4.771-1.9A6.99,6.99,0,0,1,208.376,262.108Z",
    transform: "translate(12.637 -58.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M315.151,374.074a10.328,10.328,0,0,0-20.223-3.12,10.592,10.592,0,0,0-.454,2.789c-.012.379.249.332.6.332Q305.112,374.074,315.151,374.074Z",
    transform: "translate(-88.631 -146.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M329.457,441.231H313.718a7.874,7.874,0,0,0,15.739,0Z",
    transform: "translate(-105.539 -213.663)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M30.208,428.81l-13.541,3.116a6.947,6.947,0,1,0,13.541-3.116Z",
    transform: "translate(233.678 -202.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M17.227,374.492a9.451,9.451,0,0,0-8.71-4.052C2.392,371.736.4,375.4,0,379.963a9.438,9.438,0,0,0,.209,1.868c.039.174.154.1.343.059l2.119-.486,13.541-3.116,1.014-.233,1.417-.328A9.376,9.376,0,0,0,17.227,374.492Z",
    transform: "translate(247.674 -152.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M87.313,242.449l-5.47-18.927-2.463-1.1-2.755,1.1c3.619,10.033,2.609,17.035.166,23.719-.584,1.588-1.247,3.16-1.946,4.752H78.78Z",
    transform: "translate(168.889 -24.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M206.016,64.8,199.6,63.434c-.651.059-2.514,1.623-2.514,2.6l1.366,6.944a6.268,6.268,0,0,0,1.8.265,6.205,6.205,0,0,0,5.77-8.445Z",
    transform: "translate(33.246 113.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.478,22.413a7.816,7.816,0,1,0-15.629,0,8.362,8.362,0,0,0,3.331,7.011,7.455,7.455,0,0,0,2.66,1.169V23.65c0-.98.5-1.177,1.148-1.236h8.489Z",
    transform: "translate(40.857 155.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M187.22,372.171h-5.912V375.9c0,.8.434.857,1.073.857h8.485C191.037,373.016,188.775,372.171,187.22,372.171Z",
    transform: "translate(50.938 -153.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M103.369,184.808l-7.384,2.441c-.363.324.047,3.626.292,3.519h8.584v-5.435C104.861,184.263,104.3,184.5,103.369,184.808Z",
    transform: "translate(148.504 8.329)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M149.25,206.284h3.734c2,0,2.064-3.326-.292-3.519l-3.441-.277-.923,1.955Z",
    transform: "translate(91.797 -7.186)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M192.876,167.852l-1.235-1.063c-3.094-2.666-7.005,1.833-2.869,4.519l3.481,2.259L194,174.7h5.545v-3.8l-3.445-.28Z",
    transform: "translate(41.498 24.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M238.536,219.771Z",
    transform: "translate(-4.785 -21.811)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus10);
export default __webpack_public_path__ + "static/media/status-10.1d5795773508f3a12e50ef53204b02f6.svg";
export { ForwardRef as ReactComponent };